import ButtonComponent from './button.component'

export default ButtonComponent
